import React from 'react';

const SuccessCheckmark = () => (
  <svg width="64px" height="64px" viewBox="0 0 64 64" version="1.1">
    <defs>
      <linearGradient
        x1="52.525052%"
        y1="100%"
        x2="52.525052%"
        y2="0%"
        id="linearGradient-1"
      >
        <stop stopColor="#8AC734" offset="0%" />
        <stop stopColor="#94DA31" offset="100%" />
      </linearGradient>
    </defs>
    <g
      id="Shopify-Onboarding-Pages"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="014-install-complete-copy-3"
        transform="translate(-480.000000, -120.000000)"
      >
        <g id="Verified" transform="translate(480.000000, 120.000000)">
          <circle
            id="Oval"
            fill="url(#linearGradient-1)"
            cx="31.6824647"
            cy="32.3316212"
            r="31.5"
          />
          <polyline
            id="Path-181"
            stroke="#FFFFFF"
            strokeWidth="2"
            strokeLinecap="square"
            points="18.1571568 32.8726335 26.2903553 41.0058321 44.6932669 22.6029205"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SuccessCheckmark;



// WEBPACK FOOTER //
// ./src/components/ModerationCard/ClientModerationCard/SuccessCheckmark.js